export default __webpack_public_path__ + "static/media/TshirtIllustrator.0a589601.svg";